import { createChatBotMessage } from 'react-chatbot-kit';

const config = {
  initialMessages: [createChatBotMessage(`Good afternoon. Do you need to record, enter a care note, or search your files?`)],
};

export default config;